import { Zone } from './../../Models/zone';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { group } from 'console';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Int64Updater } from 'src/app/Helpers/key-value';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ZoneService {

  apiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = environment.apiUrl;
  }

  getZones(page: number, size: number, id: number, name: string): Observable<any> {
    const url = this.apiUrl + '/api/zone/' + page + '/' + size + '/' + id
     + '/' + name + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  postZone(zone: Zone): Observable<any> {
    return this.httpclient.post(this.apiUrl + '/api/zone', zone)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  putZone(value: Int64Updater): Observable<any> {
    return this.httpclient.put(this.apiUrl + '/api/zone/' + value.Id, value)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  deleteZone(id: number): Observable<any> {
    return this.httpclient.delete(this.apiUrl + '/api/zone/' + id)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any): any {
    throw error;
    return error;
  }

}
